import { PARTIAL } from '@airtm/utils/dist/constants/accountStatus';

export default function isStatusPartial(userStatus?: string) {
  return userStatus === PARTIAL;
}
